var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DatePicker',{attrs:{"type":"date","range":"","placeholder":"Tarikh"},model:{value:(_vm.value1),callback:function ($$v) {_vm.value1=$$v},expression:"value1"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }